import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      Copyright 2026 © <a href="https://deeghost.com" target="_blank" rel="noopener noreferrer">DeeGhost.Com</a> - Sản phẩm công nghệ thuộc hệ sinh thái <a href="https://xlabit.com" target="_blank" rel="noopener noreferrer">Xlabit.Com</a>
    </footer>
  );
}
